import { gql } from 'apollo-angular';

export const GET_TERMINAL_OPERATOR_DASHBOARD = gql`
  query TerminalOperatorDashboard($pageableParam: PageableParamInput) {
    listMyTerminalOperators(pageableParam: $pageableParam) {
      totalElements
      totalPages
      number
      size
      hasNext
      hasPrevious
      content {
        id
        uuid
        name
      }
    }
  }
`;

export const GET_TERMINALS_BY_COMPANY = gql`
  query GetTerminalsByCompany($pageableParam: PageableParamInput, $companyUuid: UUID!) {
    getTerminalsByCompany(pageableParam: $pageableParam, companyUuid: $companyUuid) {
      content {
        active
        referenceNumber
        registrationType
        status
        terminalName
        uuid
        company {
          id
          name
        }
        tanks {
          active
          deleted
          capacity
          deadStock
          uuid
        }
        createdAt
      }
      totalPages
      totalElements
      size
      number
      last
      first
      pageable {
        pageNumber
        pageSize
      }
    }
  }
`;

export const GET_TERMINAL_STOCK_REPORTS = gql`
  query GetTerminalUsageStock($pageableParam: PageableParamInput) {
    getTerminalUsageStock(pageableParam: $pageableParam) {
      first
      hasContent
      hasNext
      hasPrevious
      last
      number
      numberOfElements
      size
      totalElements
      totalPages
      content {
        active
        quantity
        remarks
        reportingDate
        status
        updatedAt
        updatedBy
        uuid
        terminal {
          active
          address
          attachableDiscriminator
          bucketName
          createdAt
          createdBy
          ewuraExpireDate
          ewuraLicenseNumber
          ewuraRegDate
          lgaExpireDate
          lgaLicenseNumber
          lgaRegDate
          otherAttachmentName
          referenceNumber
          regionDistrict
          registrationType
          status
          terminalName
          updatedAt
          updatedBy
          uuid
          workflowDefinitionKey
          workflowInstanceId
          workflowStatus
        }
        productUsage {
          active
          usageName
          uuid
        }
      }
    }
  }
`;

export const GET_TERMINAL_DAILY_STOCK = gql`
  query GetTerminalDailyStock($pageableParam: PageableParamInput) {
    getTerminalDailyStock(pageableParam: $pageableParam) {
      content {
        active
        reportingDate
        status
        uuid
        submissions {
          active
          currentStock
          ullage
          uuid
          tank {
            active
            capacity
            deadStock
            status
            tankNumber
            uuid
              tankProducts {
                        active
                        uuid
                        product {
                            active
                            id
                            productName
                            allowedMix
                            uuid
                        }
                        productUnitConversion {
                            active
                            uuid
                            product {
                                id
                                productCode
                                productName
                                uuid
                            }
                            unitOfMeasure {
                                active
                                code
                                name
                                uuid
                            }
                        }
                    }
          }
        }
        terminal {
          referenceNumber
          terminalName
          uuid
          company {
            uuid
            id
            name
          }
        }
        usageList {
          active
          createdAt
          quantity
          uuid
        }
      }
      totalPages
      totalElements
      size
      numberOfElements
      number
      last
      first
      hasContent
      hasNext
      nextPageable {
        pageNumber
        pageSize
      }
      nextOrLastPageable {
        pageNumber
        pageSize
      }
      pageable {
        pageNumber
        pageSize
      }
      previousOrFirstPageable {
        pageNumber
        pageSize
      }
      previousPageable {
        pageNumber
        pageSize
      }
      sort {
        orders {
          direction
          ignoreCase
          nullHandlingHint
          property
        }
      }
    }
  }
`;

export const SUBMIT_TERMINAL_STOCK = gql`
  mutation SubmitTerminalStock($input: TerminalProductUsageReqInput!) {
    submitTerminalStock(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        createdAt
        createdBy
        quantity
        uuid
        product {
          active
          productName
          uuid
        }
      }
    }
  }
`;

export const SUBMIT_STOCK = gql`
  mutation SubmitStock($input: StockSubmissionRequestInput!) {
    submitStock(input: $input) {
      code
      data {
        active
        reportingDate
        status
        uuid
        submissions {
          active
          currentStock
          ullage
          uuid
        }
        terminal {
          active
          address
          attachableDiscriminator
          bucketName
          ewuraExpireDate
          ewuraLicenseNumber
          ewuraRegDate
          lgaExpireDate
          lgaLicenseNumber
          lgaRegDate
          otherAttachmentName
          referenceNumber
          regionDistrict
          registrationType
          status
          terminalName
          uuid
          workflowDefinitionKey
          workflowInstanceId
          workflowStatus
        }
        usageList {
          active
          quantity
          uuid
        }
      }
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const TERMINAL_DAILY_SUMMAY = gql`
  query GetTerminalDailySummary($terminalId: UUID!) {
    getTerminalDailySummary(terminalId: $terminalId) {
      code
      data {
        summary {
          totalcapacity
          totalstock
          utilization
          reporting_date
        }
        terminal_tanks_list {
          capacity
          current_stock
          product_name
          product_uuid
          status
          tank_number
          tank_uuid
          reporting_date
        }
      }
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const UPDATE_TERMINAL_STOCK = gql`
  mutation UpdateStockStatus($input: StockStatusUpdateDtoInput!) {
    updateStockStatus(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
         active
            createdAt
            createdBy
            deleted
            deletedAt
            deletedBy
            reportingDate
            status
            updatedAt
            updatedBy
            uuid
      }
    }
  }
`;

export const UPDATE_TERMINAL_STOCK_STATUS = gql`
  mutation UpdateTerminalStockStatus($input: StockStatusUpdateDtoInput!) {
    updateTerminalStockStatus(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
            createdAt
            createdBy
            deleted
            deletedAt
            deletedBy
            quantity
            updatedAt
            updatedBy
            uuid
      }
    }
  }
`;

export const UPDATE_TERMINAL_TANK = gql`
  mutation UpdateTerminalTank($input: UpdateTerminalTankInput!) {
    updateTerminalTank(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        address
        attachableDiscriminator
        bucketName
        createdAt
        createdBy
        ewuraExpireDate
        ewuraLicenseNumber
        ewuraRegDate
        lgaExpireDate
        lgaLicenseNumber
        lgaRegDate
        otherAttachmentName
        referenceNumber
        regionDistrict
        registrationType
        status
        terminalName
        updatedAt
        updatedBy
        uuid
        workflowDefinitionKey
        workflowInstanceId
        workflowStatus
        attachments {
          active
          createdAt
          createdBy
          deleted
          deletedAt
          deletedBy
          id
          minioObjectName
          otherAttachmentName
          updatedAt
          updatedBy
          uuid
        }
        bills {
          billDate
          billNumber
          billStatus
          clientName
          clientPhoneNumber
          controlNumber
          currency
          description
          id
          totalAmountAfterTax
          uuid
        }
        company {
          active
          addressDescription
          attachableDiscriminator
          brelaDataFetched
          brelaFetchedAt
          brelaRegistrationNumber
          bucketName
          companyType
          countryUuid
          createdAt
          createdBy
          deleted
          deletedAt
          deletedBy
          districtId
          id
          name
          otherAttachmentName
          postalCode
          registrationCompletedAt
          registrationStatus
          registrationType
          taxPayerCenter
          taxPayerName
          taxPayerRegion
          taxPayerRegistrationDate
          taxpayerNumber
          tin
          tinOrTaxpayerNumber
          updatedAt
          updatedBy
          uuid
          website
        }
      }
    }
  }
`;

export const GET_CURRENT_DAILY_STOCK_REPORT = gql`
  query GetCurrentDailyStock($terminalReportId: UUID) {
    getCurrentDailyStock(terminalReportId: $terminalReportId) {
      code
      extras
      fieldsErrors
      message
      status
      data {
            active
            reportingDate
            status
            uuid
            submissions {
                active
                currentStock
                ullage
                uuid
                tank {
                    active
                    attachableDiscriminator
                    bucketName
                    capacity
                    certificateIssueDate
                    certificateNumber
                    certificateValidFrom
                    certificateValidTo
                    deadStock
                    issuingAuthority
                    otherAttachmentName
                    registrationType
                    status
                    tankNumber
                    uuid
                   tankProducts {
                    active
                    uuid
                    product {
                        active
                        colorCode
                        id
                        isBps
                        minCapacityMt
                        productCode
                        productName
                        allowedMix
                        uuid
                    }
                    productUnitConversion {
                        active
                        conversionFactor
                        uuid
                        product {
                            active
                            colorCode
                            id
                            isBps
                            minCapacityMt
                            productCode
                            productName
                            uuid
                        }
                        unitOfMeasure {
                            active
                            code
                            name
                            uuid
                        }
                    }
                }
                    attachments {
                        active
                        id
                        minioObjectName
                        uuid
                        attachable {
                            id
                            registrationType
                            uuid
                        }
                        attachmentType {
                            active
                            fileSize
                            fileType
                            id
                            kind
                            name
                            uuid
                        }
                    }
                }
                productUnitConversion {
                    active
                    conversionFactor
                    uuid
                    product {
                        active
                        colorCode
                        id
                        isBps
                        minCapacityMt
                        productCode
                        productName
                        uuid
                        productCategory {
                            active
                            code
                            name
                            uuid
                        }
                    }
                    unitOfMeasure {
                        active
                        code
                        name
                        uuid
                    }
                }
            }
            terminal {
                active
                address
                attachableDiscriminator
                bucketName
                createdAt
                otherAttachmentName
                referenceNumber
                regionDistrict
                registrationType
                status
                terminalName
                uuid
                company {
                    name
                    uuid
                }
            }
            usageList {
                active
                quantity
                uuid
                productUsage {
                    active
                    isTransit
                    usageName
                    uuid
                }
                productUnitConversion {
                    active
                    conversionFactor
                    updatedAt
                    updatedBy
                    uuid
                    product {
                        active
                        colorCode
                        id
                        isBps
                        minCapacityMt
                        productCode
                        productName
                        uuid
                        productCategory {
                            active
                            code
                            name
                            uuid
                        }
                    }
                    unitOfMeasure {
                        active
                        code
                        name
                        uuid
                    }
                }
                product {
                    active
                    colorCode
                    id
                    isBps
                    minCapacityMt
                    productCode
                    productName
                    uuid
                }
            }
        }     
    }
  }
`;

export const SUBMIT_TERMINAL_REPORT = gql`
  mutation SubmitTerminalReport($input: TerminalUpdateDtoInput!) {
    submitTerminalReport(input: $input) {
      data {
        active
        reportingDate
        status
        uuid
        submissions {
          active
          currentStock
          ullage
          uuid
        }
        terminal {
          active
          address
          attachableDiscriminator
          bucketName
          ewuraExpireDate
          ewuraLicenseNumber
          ewuraRegDate
          lgaExpireDate
          lgaLicenseNumber
          lgaRegDate
          otherAttachmentName
          referenceNumber
          regionDistrict
          registrationType
          status
          terminalName
          uuid
        }
      }
      code
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const DELETE_TERMINAL_REQUEST = gql`
  mutation DeleteTerminalRequest($terminalUuid: UUID!) {
    deleteTerminalRequest(terminalUuid: $terminalUuid) {
      code
      data
      extras
      message
      status
      fieldsErrors
    }
  }
`;

export const UPDATE_OMC_USAGE_REPORT = gql`
mutation UpdateOmcUsage($input: OmcUsageUpdateReqInput!) {
    updateOmcUsage(
        input: $input
    ) {
        code
        extras
        fieldsErrors
        message
        status
        data {
            active
            createdAt
            createdBy
            deleted
            deletedAt
            deletedBy
            reportingDate
            status
            updatedAt
            updatedBy
            uuid
        }
    }
}
`;

export const UPDATE_TERMINAL_STOCK_USAGE = gql`
mutation UpdateTerminalStockUsage($input: TerminalProductUsageReqInput!) {
    updateTerminalStockUsage(
        input: $input
    ) {
        code
        extras
        fieldsErrors
        message
        status
        data {
            active
            createdAt
            quantity
            uuid
        }
    }
}`;

export const FIND_ALL_PRODUCT_UNIT_CONVERSIONS = gql`
query FindAllProductUnitConversions($pageableParam: PageableParamInput!) {
    findAllProductUnitConversions(pageableParam: $pageableParam) {
        first
        hasContent
        hasNext
        hasPrevious
        last
        number
        numberOfElements
        size
        totalElements
        totalPages
        content {
            active
            conversionFactor
            uuid
            unitOfMeasure {
                active
                code
                name
                uuid
            }
            product {
                active
                colorCode
                id
                isBps
                minCapacityMt
                productCode
                productName
                uuid
                productCategory {
                    active
                    code
                    name
                    updatedBy
                    uuid
                }
            }
        }
    }
}`;

export const DELETE_TANK = gql`
  mutation DeleteTank($tankUuid: UUID!) {
    deleteTank(tankUuid: $tankUuid) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        status
        uuid
      }
    }
  }
`;
